import React, { useRef, useMemo, useState, useEffect } from 'react'
import { Divider, Paper } from '@mui/material';
import { Button } from '@mui/material';
import Fab from '@mui/material/Fab';
import SaveIcon from '@mui/icons-material/Save';

import Swal from 'sweetalert2'
import axios from 'axios';
import api from '../../API/api';
import Loader from '../panel/loader';

import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';

import AlumniTable from '../table/viewAlumni';

import Switch from '@mui/material/Switch';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddAlumniForm = (props) => {
    // console.log("aaa===========================>>>>>>>>>>>>>>>>>", props);
    const [schools, setSchools] = useState();
    const [courses, setCourses] = useState();
    const [duration, setDuration] = useState();

    const [formdata, setFormdata] = useState({
        enrollment: '',
        registration: '',
        name: '',
        school: '',
        school_id: '',
        course: '',
        course_id: '',
        admissionYear: '',
        batch: '',
        address: '',
        email: '',
        phone: '',
        caste: '',
        dob: '',

    })

    const [alumniData, setAlumniData] = useState({
        passingYear: '',
        occupation: '',
        placedAt: '',
        designation: '',
        joinedOn: '',
        shortNote: '',
        highlights: false,
    });


    useEffect(() => {
        getSchool()
    }, []);

    useEffect(() => {
        setStep(1);
        if (props.rowdata !== '') {
            handleProcced(props.rowdata)
        }
        // console.log(props, 'props.rowdata');
    }, [props.rowdata]);

    useEffect(() => {
        setStep(2)
    }, [props.step])

    useEffect(() => {
        if (props.user) {
            setFormdata(props.user)
        }
    },[props])


    const getSchool = () => {
        api.getSchools().then((res) => {
            // console.log(res);
            setSchools(res.data.schools)
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }

    const handelSchool = (e) => {
        setFormdata({
            ...formdata,
            [e.target.name]: e.target.value
        })

        // if (e.target.value) {
        //     getCourses(e.target.value)
        // }
    }

    const [photo, setPhoto] = useState();
    const handleProfilePhoto = (e) => {
        setPhoto(e.target.files[0]);
    }

    useEffect(() => {
        if (formdata?.school) {
            getCourses(formdata?.school)
        }
    }, [formdata?.school])


    const getCourses = (id) => {
        api.getCourses(id).then((res) => {
            // console.log("course", res);
            setCourses(res.data.courses)
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }

    const handleBatch = (e) => {
        setFormdata({
            ...formdata,
            [e.target.name]: e.target.value,
            batch: new Date(e.target.value.replace('-', '/') + '/01').getFullYear()
        })
    }

    const handleForm = (e) => {
        setFormdata({
            ...formdata,
            [e.target.name]: e.target.value
        })

        if (e.target.name === 'course') {
            var course = courses.filter((x) => x.id == e.target.value)
            var duration = course[0].duration;
            // console.log("duration", duration);
            setDuration(duration);
        }
    }

    const handleAlumni = (e) => {
        setAlumniData({
            ...alumniData,
            [e.target.name]: e.target.value
        })
    }

    const submitData = () => {

        if (formdata.registration == null || formdata.registration == undefined) {
            Swal.fire({
                title: 'Error!',
                text: 'Reg no Cannot be empty !',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }
        if (formdata.enrollment == null || formdata.enrollment == undefined) {
            Swal.fire({
                title: 'Error!',
                text: 'Enrollment id Cannot be empty !',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }
        if (formdata.name == null || formdata.name == undefined) {
            Swal.fire({
                title: 'Error!',
                text: 'Name Cannot be empty !',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }
        if (formdata.dob == null || formdata.dob == undefined) {
            Swal.fire({
                title: 'Error!',
                text: 'DOB Cannot be empty !',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }
        if (formdata.phone == null || formdata.phone == undefined) {
            Swal.fire({
                title: 'Error!',
                text: 'Phone Cannot be empty !',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }
        // if (formdata.passingYear == '' ) {
        //     Swal.fire({
        //         title: 'Error!',
        //         text: 'Passing Year Cannot be empty !',
        //         icon: 'error',
        //         confirmButtonText: 'Ok'
        //     })
        //     return;
        // }

        // console.log(alumniData);
        // return;
        const postData = new FormData();
        postData.append('enrollment', formdata.enrollment)
        postData.append('registration', formdata.registration)
        postData.append('name', formdata.name)
        postData.append('school', formdata.school)
        postData.append('course', formdata.course)
        postData.append('admissionYear', formdata.admissionYear)
        postData.append('batch', formdata.batch)
        postData.append('address', formdata.address)
        postData.append('email', formdata.email)
        postData.append('phone', formdata.phone)
        postData.append('caste', formdata.caste)
        postData.append('dob', formdata.dob)
        // if (!props?.dash) {
            postData.append('passingYear', alumniData?.passingYear)
            postData.append('occupation', alumniData?.occupation)
            postData.append('placedAt', alumniData?.placedAt)
            postData.append('designation', alumniData?.designation)
            postData.append('joinedOn', alumniData?.joinedOn)
            postData.append('shortNote', alumniData?.shortNote)
            postData.append('highlights', alumniData?.highlights)
            postData.append('photo', photo)
        // }

        if (props.from === 'public') {
            postData.append('isApprove', 0)
        }
        else {
            postData.append('isApprove', 1)

        }


        axios.post(`${process.env.REACT_APP_MAIN_API}saveAlumni`, postData)
            .then((res) => {
                // console.log("=>", res);


                if (res.data.status === 200) {
                    props.handleClose();
                    setStep(1);
                    Swal.fire({
                        title: 'Success!',
                        text: 'Added Succeffully !',
                        icon: 'success',
                        confirmButtonText: 'Ok'
                    })
                }
                else if (res.data.status === 409) {
                    toast.error(res.data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
                else {
                    toast.error('Something Went Wrong !', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }

            })
            .catch((err) => {
                // console.log(err.response);
                toast.error('Something Went Wrong.. !', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            })
    }

    const [step, setStep] = useState(1);
    const [load, setLoad] = useState(false);
    const nextStep = () => {
        switch (step) {
            case 1:
                return (
                    <>
                        {form1()}
                    </>
                )

            case 2:
                return (
                    <>
                        {form2()}
                    </>
                )
            case 3:
                return (
                    <>
                        {form3()}
                    </>
                )
            case 4:
                return (
                    <>
                        {form4()}
                    </>
                )
            default:
                { form1() };
                break;
        }

    }

    const stepper = () => {
        return (
            <>
                <Paper elevation={6}>
                    <Divider sx={{ borderBottomWidth: '1px', borderBottomColor: 'black' }} />
                    <div className='row justify-content-center p-2'>

                        <Fab color={step === 1 ? 'secondary' : ''} size='small' variant="extended" aria-label="edit">
                            <div className="row">
                                <div> <small>1  </small></div>
                            </div>
                        </Fab>
                        <Fab color={step === 2 ? 'secondary' : ''} size='small' variant="extended" aria-label="edit">
                            <div className="row">
                                <div> <small>2 </small></div>
                            </div>
                        </Fab>
                        <Fab color={step === 3 ? 'secondary' : ''} size='small' variant="extended" aria-label="edit">
                            <div className="row">
                                <div> <small>3 </small></div>
                            </div>
                        </Fab>
                        <Fab color={step === 4 ? 'secondary' : ''} size='small' variant="extended" aria-label="edit">
                            <div className="row">
                                <div> <small>4 </small></div>
                            </div>
                        </Fab>
                    </div>
                    <Divider sx={{ borderBottomWidth: '5px', borderBottomColor: 'black' }} />
                </Paper>
            </>
        )
    }
    const stepperWebsite = () => {
        return (
            <>
                <Paper elevation={6}>
                    <Divider sx={{ borderBottomWidth: '1px', borderBottomColor: 'black' }} />
                    <div className='row justify-content-center p-2'>

                        <Fab color={step === 2 ? 'secondary' : ''} size='small' variant="extended" aria-label="edit">
                            <div className="row">
                                <div> <small>1 </small></div>
                            </div>
                        </Fab>
                        <Fab color={step === 3 ? 'secondary' : ''} size='small' variant="extended" aria-label="edit">
                            <div className="row">
                                <div> <small>2 </small></div>
                            </div>
                        </Fab>
                        {
                            !props?.dash === true ?
                                <Fab color={step === 4 ? 'secondary' : ''} size='small' variant="extended" aria-label="edit">
                                    <div className="row">
                                        <div> <small>3 </small></div>
                                    </div>
                                </Fab> : ''
                        }
                    </div>
                    <Divider sx={{ borderBottomWidth: '5px', borderBottomColor: 'black' }} />
                </Paper>
            </>
        )
    }


    const stepfooter = () => {
        return (
            <>
                <Paper elevation={6}>
                    <div className='p-2 mt-2'>
                        <div className='d-flex justify-content-between'>
                            {
                                props?.hide && step < 3 ? <div></div>
                                    :
                                    <div>
                                        {step !== 1 &&
                                            <Button variant='contained' color='secondary' onClick={() => setStep(step - 1)}>Previous</Button>
                                        }
                                    </div>
                            }
                            <div>
                                {step !== 4 ?
                                    <Button variant='contained' className='ml-auto' onClick={() => setStep(step + 1)}>Next</Button> :

                                    <Button variant='contained' color='success' disabled={load ? true : false} onClick={submitData}>Save <SaveIcon fontSize='small' /></Button>
                                }
                            </div>
                        </div>
                    </div>
                </Paper>
            </>
        )
    }
    const stepFooterDashboard = () => {
        return (
            <Paper elevation={6}>
                <div className='p-2 mt-2'>
                    <div className='d-flex justify-content-between'>
                        {
                            props?.hide && step < 3 ? <div></div>
                                :
                                <div>
                                    {step !== 1 &&
                                        <Button variant='contained' color='secondary' onClick={() => setStep(step - 1)}>Previous</Button>
                                    }
                                </div>
                        }
                        <div>
                            {/* {
                                !props?.dash ?
                                <Button variant='contained' className='ml-auto' onClick={() => setStep(step + 1)}>Next</Button>
                                :   
                                <Button variant='contained' color='success' disabled={load ? true : false} onClick={submitData}>Save <SaveIcon fontSize='small' /></Button>
                            } */}
                            {step !== 3 ?
                                <Button variant='contained' className='ml-auto' onClick={() => setStep(step + 1)}>Next</Button> :

                                <Button variant='contained' color='success' disabled={load ? true : false} onClick={submitData}>Save <SaveIcon fontSize='small' /></Button>
                            }

                        </div>
                    </div>
                </div>
            </Paper>
        )
    }


    const [search, setSearch] = useState();
    const [data, setData] = useState();


    const handleSearch = (e) => {
        // searchStudent(e.target.value);
        setSearch(e.target.value)
    }

    const searchData = () => {
        searchStudent(search)
    }

    const searchStudent = (data) => {
        api.searchStudent(data).then((res) => {
            // console.log(res);
            setData(res.data.searchData);
            if (res.data.searchData.length === 0) {
                Swal.fire({
                    title: 'Data Not Found',
                    text: 'Want to add Student? ',
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cencel',
                    confirmButtonColor: 'green',
                    confirmButtonText: 'Yes, Proceed ...'
                }).then((el) => {
                    // console.log(el);
                    setStep(2);
                    return;
                })
            }
        })
            .catch((err) => {
                //  console.log(err.response)
                 })
    }

    const handleProcced = (row) => {
        setStep(2);
        // console.log("--------->", row);
        // return;
        // setFormdata(row);
        setFormdata({
            enrollment: row?.enrollment,
            registration: row?.registration,
            name: row?.name,
            school: row?.school_id,
            school_id: row?.school_id,
            course: row?.course_id,
            course_id: row?.course_id,
            admissionYear: row?.admissionYear,
            batch: row?.batch,
            address: row?.address,
            email: row?.email,
            phone: row?.phone,
            caste: row?.caste,
            dob: row?.dob,
        });
        setAlumniData(row);
    }

    const highlightsCheck = () => {
        console.log('kk');
        setAlumniData({
            ...alumniData,
            'highlights': !alumniData.highlights
        })

    }

    const form1 = () => {
        return (
            <>
                <Paper elevation={5}>
                    <div className='p-3' style={{ minHeight: '400px' }}>
                        <div className='row justify-content-center align-items-center'>


                            <Paper
                                elevation={3}
                                component="form"
                                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 700 }}
                            >

                                <InputBase
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder="Search Student with Enrollment No/Student Name"
                                    inputProps={{ 'aria-label': 'Search Student with Enrollment No/Student Name' }}
                                    name='search'
                                    onChange={handleSearch}
                                />
                                <Button type="button" variant='contained' color='success' size='small' aria-label="search" onClick={searchData}>
                                    <SearchIcon /> <small> Search </small>
                                </Button>
                                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                <Button color="primary" variant='contained' size='small' aria-label="directions" onClick={() => setStep(2)}>
                                    <DirectionsIcon /> <small>Create New Student ?</small>
                                </Button>
                            </Paper>
                            <div className='text-center m-2 p-2'>
                                <span className='text-success'> <strong> Search Student with Enrollment No or with name if Student is Already an User or You can create a new one. </strong> </span>
                            </div>


                            {data &&
                                <AlumniTable data={data} handleProcced={handleProcced} />
                            }
                        </div>

                    </div>
                </Paper>

            </>
        )
    }
    const form2 = () => {
        console.log(!props.dash,'props.dash');
        return (
            <>
                <Paper elevation={3}>
                    <div className='p-3'>
                        <div className="row">

                            <div className="col-md-12 form-group p-2">
                                <label>Student Name</label>
                                <input type="text" className="form-control" name='name' value={formdata?.name} onChange={handleForm} id="" placeholder="Enter Student Name" />
                            </div>

                            <div className="col-md-6 form-group p-2">
                                <label>Registration No</label>
                                <input type="text" className="form-control" name='registration' value={formdata?.registration} onChange={handleForm} id="" placeholder="" disabled={props?.disabled} />
                            </div>
                            <div className="col-md-6 form-group p-2">
                                <label>Roll No</label>
                                <input type="text" className="form-control" name='enrollment' value={formdata?.enrollment} onChange={handleForm} id="" placeholder="" />
                            </div>


                            <div className="col-md-6 form-group p-2">
                                <label>School</label>
                                {/* <input type="text" className="form-control" name='school' value={formdata?.school} onChange={handleForm} id="" placeholder="" /> */}

                                <select name="school" value={formdata?.school} className='form-control' onChange={handelSchool} id="">
                                    <option value="">-Select-</option>
                                    {schools && schools.map((el) => (
                                        <option value={el.id} >{el.schoolName}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-6 form-group p-2">
                                <label>Course</label>
                                {/* <input type="text" className="form-control" name='course' value={formdata?.course} onChange={handleForm} id="" placeholder="" /> */}

                                <select name="course" value={formdata?.course} onChange={handleForm} className='form-control' id="">
                                    <option value="">-Select-</option>
                                    {courses && courses.map((el) => (
                                        <option value={el.id}>{el.courseName} ({el.effected_from} - {el.effected_to})</option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-6 form-group p-2">
                                <label>Admission Year</label>
                                <input type="month" className="form-control" name='admissionYear' value={formdata?.admissionYear} onChange={handleBatch} id="" placeholder="" />
                            </div>



                            <div className="col-md-6 form-group p-2">
                                <label>Batch</label>
                                <input type="text" className="form-control" name='batch' value={formdata?.batch} onChange={handleForm} id="" placeholder="" />
                            </div>

                        </div>

                    </div>
                </Paper>
            </>
        )
    }
    const form3 = () => {
        return (
            <>
                <Paper elevation={3}>
                    <div className='p-3'>
                        <div className="row">

                            <div className="col-md-12 form-group p-2">
                                <label for="">Address</label>
                                <input type="text" className="form-control" name='address' value={formdata?.address} onChange={handleForm} id="" placeholder="" />
                            </div>

                            <div className="col-md-6 form-group p-2">
                                <label for="">Email</label>
                                <input type="email" className="form-control" name='email' value={formdata?.email} onChange={handleForm} id="" placeholder="" />
                            </div>
                            <div className="col-md-6 form-group p-2">
                                <label for="">Phone No</label>
                                <input type="number" className="form-control" name='phone' value={formdata?.phone} onChange={handleForm} id="" placeholder="" />
                            </div>
                            <div className="col-md-6 form-group p-2">
                                <label for="">Caste</label>
                                <select name="caste" className="form-control" value={formdata?.caste} onChange={handleForm} id="">
                                    <option value="">--Select--</option>
                                    <option value="General">General</option>
                                    <option value="OBC">OBC</option>
                                    <option value="SC">SC</option>
                                    <option value="ST(P)">ST(P)</option>
                                    <option value="ST(H)">STP(H)</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div className="col-md-6 form-group p-2">
                                <label for="">Date of Birth</label>
                                <input type="date" className="form-control" name='dob' value={formdata?.dob} onChange={handleForm} id="" placeholder="" />
                            </div>

                        </div>
                    </div>
                </Paper>
            </>
        )
    }
    const form4 = () => {
        return (
            <>
                <Paper elevation={3}>
                    <div className='p-3'>
                        <div className="row">

                            <div className="col-md-4 form-group p-2">
                                <label>Passing Year</label>
                                <input type="month" className="form-control" name='passingYear' value={alumniData?.passingYear} onChange={handleAlumni} />
                            </div>

                            <div className="col-md-4 form-group p-2">
                                <label>Occupation</label>
                                <input type="text" className="form-control" name='occupation' value={alumniData?.occupation} onChange={handleAlumni} />
                            </div>

                            <div className="col-md-4 form-group p-2">
                                <label>Profile Photo</label>
                                <input type="file" className="form-control" name='photo' onChange={handleProfilePhoto} />
                            </div>

                            <div className="col-md-4 form-group p-2">
                                <label>Placed At</label>
                                <input type="text" className="form-control" name='placedAt' value={alumniData?.placedAt} onChange={handleAlumni} />
                            </div>

                            <div className="col-md-2 form-group p-2">
                                <label>Show on Highlights</label>
                                <Switch name='highlights' onChange={highlightsCheck} checked={alumniData?.highlights} />


                            </div>


                            <div className="col-md-4 form-group p-2">
                                <label>Position/Designation</label>
                                <input type="text" className="form-control" name='designation' value={alumniData?.designation} onChange={handleAlumni} id="" />
                            </div>
                            <div className="col-md-2 form-group p-2">
                                <label>Joined On</label>
                                <input type="date" className="form-control" name='joinedOn' value={alumniData?.joinedOn} onChange={handleAlumni} id="" />
                            </div>


                            <div className="col-md-12 form-group p-2">
                                <label>Alumni Speak (It will reflect on Alumni Speack Section, Leave blank if there is nothing)</label>
                                {/* <input type="text" className="form-control" name='shortNote' value={alumniData.shortNote} onChange={handleAlumni}  /> */}
                                <textarea name='shortNote' onChange={handleAlumni} className='form-control' rows="5">
                                    {alumniData?.shortNote}
                                </textarea>
                            </div>
                        </div>
                    </div>
                </Paper>
            </>
        )
    }





    return (
        <>
            <ToastContainer />
            <div className='p-2'>
                {
                    props?.hide ?
                        <>{stepperWebsite()}</>
                        :
                        <>
                            {stepper()}
                        </>
                }
                {nextStep()}
                {
                    !props?.dash ?
                        <>
                            {stepfooter()}
                        </>
                        :
                        <>
                            {stepFooterDashboard()}
                        </>
                }

            </div>
        </>
    )
}

export default AddAlumniForm;